import React from 'react';
import { UserCheck, Store, Building2 } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';

export default function AuditorAnalytics({ auditors }) {
    const analytics = React.useMemo(() => {
        const totalAuditors = auditors?.length || 0;
        const moderno = auditors?.filter((a) => a.channel === 'moderno')?.length || 0;
        const tradicional = auditors?.filter((a) => a.channel === 'tradicional')?.length || 0;

        return { totalAuditors, moderno, tradicional };
    }, [auditors]);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            <StatCard
                label="Total Auditores"
                value={formatNumber(analytics.totalAuditors)}
                icon={<UserCheck />}
                tone="brand"
                hint="Auditores registrados"
            />
            <StatCard label="Canal Moderno" value={formatNumber(analytics.moderno)} icon={<Building2 />} tone="info" hint="Auditores asignados" />
            <StatCard
                label="Canal Tradicional"
                value={formatNumber(analytics.tradicional)}
                icon={<Store />}
                tone="warning"
                hint="Auditores asignados"
            />
        </div>
    );
}
